module.exports = __webpack_public_path__ + "img/2.08542e5d.png";